import Toast, { ToastShowParams } from 'react-native-toast-message';

export const showSuccessToast = (params: ToastShowParams) => Toast.show(params);

export const showInfoToast = (params: ToastShowParams) =>
  Toast.show({
    type: 'info',
    ...params,
  });

export const showErrorToast = (params: ToastShowParams) =>
  Toast.show({
    type: 'error',
    ...params,
  });
